import React from "react";
import "../styles/BranchBanking.css";
import {Link} from "react-router-dom";

function BranchBanking() {
    return (
        <div className="branchbank-wrapper">

            {/* HERO */}

            <section className="branchbank-hero">
                <div className="branchbank-hero-text">
                    <h1>Branch Banking</h1>
                </div>
            </section>

            {/* CONTENT */}

            <section className="branchbank-content">

                <p>
                    We cater to all your financial needs in one place, and our commitment
                    to providing quality service with a smile is best felt at our branches.
                    The Sahyadri Sahakari Bank invites you and your loved ones to visit the
                    nearest TSSBLM Bank Branch, share a cup of tea, and discuss the multitude
                    of dreams you aspire to fulfill.
                </p>

                <p>
                    We offer comprehensive and personalized banking services with a
                    straightforward goal — turning your dreams into reality. Our friendly
                    staff ensures every customer receives individual attention, whether
                    you are opening your first account or planning long-term investments.
                </p>

                <h2>Services Offered</h2>

                <ul>
                    <li><strong>Account Opening:</strong> Open Savings, Current and other accounts.</li>

                    <li><strong>Cash Transactions:</strong> Withdrawal and Deposit of Cash.</li>

                    <li><strong>Cheque Services:</strong> Cheque Book requests, stop payment of issued cheques.</li>

                    <li><strong>Clearing:</strong> Inward / Outward Cheque Clearing.</li>

                    <li><strong>Fund Transfers:</strong> Transfer funds within the Bank, NEFT, RTGS and IMPS.</li>

                    <li><strong>Fixed Deposits:</strong> Book Term Deposits for secure savings.</li>

                    <li><strong>DD / PO:</strong> Issue Demand Drafts and Pay Orders.</li>

                    <li><strong>Safe Deposit Lockers:</strong> Allotment, operation and surrender of lockers.</li>

                    <li><strong>Loans:</strong> Application and servicing of various loan products.</li>

                    <li><strong>Miscellaneous Services:</strong> Submission of KYC documents, collection of Debit Cards, Cheque Books and other deliverables.</li>
                </ul>

                <p>
                    Our Branch Banking services are designed to support individuals,
                    families, entrepreneurs and small businesses. From everyday banking
                    needs to long-term financial planning, we are committed to being your
                    trusted financial partner.
                </p>

                <p>
                    Visit your nearest branch today and experience personalized service,
                    transparent banking and a warm community connection that puts people
                    first.
                </p>
                <Link to="/branches"><button className="branch-btn">Locate Branches</button></Link>

            </section>

        </div>
    );
}

export default BranchBanking;
